import React from 'react'
import { images } from '../../assets'

const ErrorPopup = ({ open, setErrorPopupState, errorPopupMessage }) => {
  if (open) {
    document.querySelector('.application_sheet').scrollTop = 0
  }
  return (
    <div className="ErrorPopup">
      <div className={open ? 'open error_popup notice_popup' : 'error_popup notice_popup'}>
        <div className="logo_brg"></div>
        <p>
          서비스 신청중 <br /> 문제가 발생했습니다.
        </p>
        <div className="text-center">{errorPopupMessage}</div>
        <div className="logo_caution"></div>
        <div>
          <div className="error_box preview">
            <p>
              지속적으로 문제가 발생되면 <br /> 고객센터로 문의 부탁드립니다.
            </p>
            <p>
              <img src={images.call} alt="call" />
              <span className="bold">050-7964-1000</span>
            </p>
          </div>
          <button type="button" className="btn_default" onClick={() => setErrorPopupState(false)}>
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export { ErrorPopup }
